import { TextStyle } from "@tiptap/extension-text-style"
import { TEXT_COLOR_MAP } from "../../util/colors"
import { htmlMarkTokenizer, parseHtmlMark, renderHtmlMark } from "../../util/markdown-html-mark"
import { shouldIncludeAttributes } from "../../util/markdown-options"

export const TextStyleContentExtension = TextStyle.extend({
  markdownTokenName: "textStyle",
  // A plain <span> is not a mark, so only a colored one is read as text color.
  markdownTokenizer: htmlMarkTokenizer("textStyle", "span", { requireColor: true }),
  renderMarkdown: (node, helpers) =>
    node.attrs?.color && shouldIncludeAttributes()
      ? renderHtmlMark(node, helpers, "span", TEXT_COLOR_MAP)
      : helpers.renderChildren(node.content || []),
  parseMarkdown: (token, helpers) => parseHtmlMark(token, helpers, "textStyle", TEXT_COLOR_MAP),
})
